import {FC, useEffect, useState} from 'react'
import {KTSVG} from '../../../../_metronic/helpers'
import {getFile} from '../../../services/files'
import catalogStyles from '../catalogo.module.css'

type Props = {
  imageKey?: string | null
  size?: 'sm' | 'lg'
  fallbackIcon?: string
}

const CatalogItemImage: FC<Props> = ({
  imageKey,
  size = 'sm',
  fallbackIcon = '/media/icons/duotune/ecommerce/ecm008.svg',
}) => {
  const [url, setUrl] = useState<string | null>(null)

  useEffect(() => {
    let active = true

    const load = async () => {
      if (!imageKey) {
        if (active) setUrl(null)
        return
      }

      try {
        const response = await getFile(imageKey)
        if (active) setUrl(response?.url || null)
      } catch {
        if (active) setUrl(null)
      }
    }

    load()

    return () => {
      active = false
    }
  }, [imageKey])

  if (url) {
    return (
      <img
        src={url}
        alt=''
        className={size === 'lg' ? catalogStyles.imagePreviewLarge : catalogStyles.thumb}
      />
    )
  }

  return (
    <div className={size === 'lg' ? catalogStyles.imagePreviewFallback : catalogStyles.thumbFallback}>
      <KTSVG path={fallbackIcon} className={size === 'lg' ? 'svg-icon-3x' : 'svg-icon-2x'} />
    </div>
  )
}

export {CatalogItemImage}
